import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {SearchableLanguage} from '@/profile-creation-wizard/components/for-creation/store';

export default class LanguageSearcher {
    searchableLanguages: Array<SearchableLanguage> = [];

    async loadLanguages(): Promise<void> {
        if (this.searchableLanguages.length > 0) {
            return;
        }

        const seed = new Date();
        const [data, error] = await context.httpService.get<Array<SearchableLanguage>>(
            `${context.registry.entries.languagesRegistry()}?randomseed=${seed.getMilliseconds()}`,
        );

        if (data && !error) {
            this.searchableLanguages = data;
        }
    }

    search(query: string): Promise<HttpServiceResponse<any>> {
        const results = this.searchableLanguages.map((lang) => lang.name).filter((name) => this.sanitize(name).includes(this.sanitize(query)));
        return Promise.resolve([results, null] as HttpServiceResponse<any>);
    }

    getCodeByName(languageName: string): string {
        return this.searchableLanguages.filter((lang) => this.sanitize(lang.name) === this.sanitize(languageName))[0].code;
    }

    findByCode(languageCode: string): SearchableLanguage | null {
        const languagesFound = this.searchableLanguages.filter((lang) => this.sanitize(lang.code) === this.sanitize(languageCode));
        if (languagesFound.length === 1) {
            return languagesFound[0];
        }
        return null;
    }

    sanitize(lang: string): string {
        if (!lang) {
            return '';
        }

        return lang
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }
}
